var scrolledPosition = 0;
var isScrolling = false;

var largeBreakpoint = 1250;
var mediumBreakPoint = 1000;
var smallBreakPoint = 580;

export function isXLarge() {
  return window.innerWidth >= largeBreakpoint;
}

export function isLarge() {
  return window.innerWidth > mediumBreakPoint;
}

export function isMedium() {
  return window.innerWidth > smallBreakPoint && window.innerWidth <= mediumBreakPoint;
}

export function isSmall() {
  return window.innerWidth <= smallBreakPoint;
}

export function getScreenSize() {
  if (isLarge()) {
    return 'large';
  }

  if (isMedium()) {
    return 'medium';
  }

  return 'small';
}

export function disablePageScroll() {
  if ($('body').hasClass('disabled-scroll')) return;

  scrolledPosition = $(window).scrollTop();
  isScrolling = $('body').hasClass('scrolling');

  $('body').addClass('disabled-scroll').css('overflow', 'hidden');
  $('#page-wrapper').css('margin-top', -scrolledPosition);
  if (isScrolling) {
    $('body').addClass('forced-scrolling');
  }
}

export function enablePageScroll() {
  $('body').removeClass('disabled-scroll').css('overflow', '');
  $('#page-wrapper').css('margin-top', '');
  $(window).scrollTop(scrolledPosition);
  $('body').removeClass('forced-scrolling');
}
